import { config } from "../config/config";
import { commonFunctions } from "../utils/commonFunctions";

export const authServices = {
    userRegister,
    userPreference,
    totalUser,
    merchantRegister,
    merchantPreferencer,
    totalMerchant,
    influencerRegister,
    totalInfluencer
    // login,

}

function userRegister(data) {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("POST", extraHeaders, JSON.stringify(data));
    return fetch(`${config.localApiUrl}/normal-users`, requestOptions).then(response => response.json());
}
function userPreference(data) {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("POST", extraHeaders, JSON.stringify(data));
    return fetch(`${config.localApiUrl}/normal-users-preference`, requestOptions).then(response => response.json());
}
function totalUser() {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("GET", extraHeaders);
    return fetch(`${config.localApiUrl}/normal-users/total`, requestOptions).then(response => response.json());
}

function merchantRegister(data) {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("POST", extraHeaders, JSON.stringify(data));
    return fetch(`${config.localApiUrl}/business-users`, requestOptions).then(response => response.json());
}

function merchantPreferencer(data) {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("POST", extraHeaders, JSON.stringify(data));
    return fetch(`${config.localApiUrl}/business-user-preferences`, requestOptions).then(response => response.json());
}
function totalMerchant() {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("GET", extraHeaders);
    return fetch(`${config.localApiUrl}/business-users/count`, requestOptions).then(response => response.json());
}

function influencerRegister(data) {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("POST", extraHeaders, JSON.stringify(data));
    return fetch(`${config.localApiUrl}/influencers`, requestOptions).then(response => response.json());
}

function totalInfluencer() {
    const extraHeaders = {
        "Content-Type": "application/json"
    };
    const requestOptions = commonFunctions.getRequestOptions("GET", extraHeaders);
    return fetch(`${config.localApiUrl}/influencers/total`, requestOptions).then(response => response.json());
}

// function login(data) {
//     const extraHeaders = {
//         "Content-Type": "application/json"
//     };
//     const requestOptions = commonFunctions.getRequestOptions("POST", extraHeaders, JSON.stringify(data));
//     return fetch(`${config.localApiUrl}/api/user/login`, requestOptions).then(response => response.json());
// }